module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why would a pronounced historical purist write ghost tales? More than once I have faced that question. Basically, it is because of public demand. For several years, I have been pressured to write such a book. In my constant quest for historical information, I have heard hundreds of ghost tales. They seem to be a byproduct of historical research.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4736dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preface.vue
// module id = 69
// module chunks = 0